import { render, staticRenderFns } from "./ModalServices.vue?vue&type=template&id=494b50f3&lang=pug&"
import script from "./ModalServices.vue?vue&type=script&lang=js&"
export * from "./ModalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports